import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { EmbeddingsInputs, Model } from "../../../services/api/instances/embeddingsApi/types";
import { INITIAL_INPUT_VALUES } from "../constants";
import { checkEmptyValue } from "../helpers";
import { getEmbeddingsModelsReducerBuilder, getEmbeddingsVectorsReducerBuilder } from "./reducers";
import type { EmbeddingsState } from "./types";

const initialState: EmbeddingsState = {
  models: [],
  selectedModel: null,
  vectors: null,
  coordinates: [],
  inputValues: INITIAL_INPUT_VALUES,
  isLoading: false,
  isDisabled: true,
};

const embeddingsSlice = createSlice({
  name: "embeddings",
  initialState,
  reducers: {
    setModelsAction: (state, action: PayloadAction<Model[]>) => {
      state.models = action.payload;
    },
    setSelectedModelAction: (state, action: PayloadAction<Model>) => {
      state.selectedModel = action.payload;
    },
    setInputValues: (state, action: PayloadAction<EmbeddingsInputs[]>) => {
      state.inputValues = action.payload;
    },
    updateInputValues: (state, action: PayloadAction<EmbeddingsInputs>) => {
      state.inputValues = state.inputValues.map((input) => {
        if (input.id === action.payload.id) {
          return action.payload;
        }
        return input;
      });
    },
    setIsDisabled: (state) => {
      const values = state.inputValues;
      state.isDisabled = !(state.selectedModel && values.length >= 3 && !checkEmptyValue(values));
    }
  },
  extraReducers: (builder) => {
    getEmbeddingsModelsReducerBuilder(builder);
    getEmbeddingsVectorsReducerBuilder(builder);
  }
});

export const embeddingsReducers = embeddingsSlice.reducer;
export const {
  setModelsAction,
  setSelectedModelAction,
  setInputValues,
  updateInputValues,
  setIsDisabled
} = embeddingsSlice.actions;